__turbopack_context__.v({
  "footer": "phone-number-card-module-scss-module__3dErSW__footer",
  "info": "phone-number-card-module-scss-module__3dErSW__info",
  "info-icon": "phone-number-card-module-scss-module__3dErSW__info-icon",
  "info-rules": "phone-number-card-module-scss-module__3dErSW__info-rules",
  "input": "phone-number-card-module-scss-module__3dErSW__input",
  "title": "phone-number-card-module-scss-module__3dErSW__title",
});
